import { AppModule } from 'app/module';
import { mediaQueries } from 'util/mediaQueries';
import Template from './template.hbs';
import './styles.scss';

export class MemoSaveModal extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            closeIcon: '.m-memoSaveModal__closeIcon',
            cancelButton: '.m-memoSaveModal__cancelButton',
            saveButton: '.m-memoSaveModal__saveButton',
            overlay: '.m-memoSaveModal__overlay',
            headline: '.m-memoSaveModal__headline',
            text: '.m-memoSaveModal__text',
        };
    }

    getPropsFromDom() {
        return {
            visible: !this.dom.el.classList.contains('m-memoSaveModal--hide'),
            headline: this.dom.headline ? this.dom.headline.innerText : '',
            modalText: this.dom.text ? this.dom.text.innerText : '',
            saveButtonText: this.dom.saveButton ? this.dom.saveButton.innerText : '',
            cancelButtonText: this.dom.cancelButton ? this.dom.cancelButton.innerText : '',
            disabelSaveButton: this.dom.saveButton.classList.contains('m-memoSaveModal__saveButton--disabled'),
        };
    }

    domEvents() {
        if (this.dom.saveButton) {
            this.dom.saveButton.addEventListener('click', () => this.save());
        }

        if (this.dom.closeIcon) {
            this.dom.closeIcon.addEventListener('click', () => this.closeModalViaClick());
        }

        if (this.dom.cancelButton) {
            this.dom.cancelButton.addEventListener('click', () => this.redirect());
        }

        if (this.dom.overlay) {
            this.dom.overlay.addEventListener('click', () => this.closeModalViaClick());
        }
    }

    save(e) {
        if (e) e.preventDefault();
        this.events.emit('saveMemo');
    }

    closeModalViaClick() {
        if (mediaQueries.isMobile()) {
            window.history.back();
        } else {
            this.closeModal();
        }
    }

    closeModal() {
        this.updateProps({ visible: false, errors: false }, true);
        this.events.emit('removeModalStyle');
    }

    openModalViaClick(disabelSaveButton = false, link = false) {
        this.updateProps({ visible: true, disabelSaveButton, link }, true);
        this.events.emit('addModalStyle');

        if (mediaQueries.isMobile()) {
            this.events.emit('pushStateMemoSaveModal');
        }
    }

    openModal() {
        this.updateProps({ visible: true }, true);
        this.events.emit('addModalStyle');
    }

    isOpen() {
        return this.props.visible;
    }

    redirect() {
        this.setProps(Object.assign(this.props, { abortLinkClicked: true }));
        if (mediaQueries.isMobile()) {
            window.history.back();
        } else {
            window.location.href = this.props.link;
        }
    }
}
